import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default class BudgetRating extends Component {
  static propTypes = {
    rating: PropTypes.number.isRequired,
  }

  render () {
    const { rating } = this.props

    const text = []

    for (let i = 1; i <= rating; i++) {
      text.push('€')
    }

    return (
      <>{text.join('')}</>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/BudgetRating.js